import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader_main">
      <div className="loader triangle">
        <svg viewBox="0 0 86 80">
          <polygon points="43 8 79 72 7 72"></polygon>
        </svg>
      </div>
    </div>
  );
};

export default Loader;
